module.exports = __webpack_public_path__ + "static/media/Zuhe-min.3a26050f.png";